export default __webpack_public_path__ + "static/media/gallery_06.25013ee5.jpg";